

























































import { ClientAccountsApi } from '@/api/client-accounts';
import editWillHistoryItemDialog from '@/components/client/view-client/edit-will-history-item-dialog.vue';
import viewWillHistoryItemDialog from '@/components/client/view-client/view-will-history-item-dialog.vue';
import { ClientAccount } from '@/shared/clients/client-account';
import { ClientAccountWill } from '@/shared/clients/client-account-will';
import { User } from '@/shared/user';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const userModule = namespace('user');
const usersModule = namespace('users');
const clientApi = new ClientAccountsApi();

@Component({
    components: {
        viewWillHistoryItemDialog,
        editWillHistoryItemDialog,
    },
})
export default class WillHistory extends Vue {
    @userModule.Getter('isAdministrator') public isAdministrator!: boolean;

    @usersModule.Getter('users') private users!: Array<User>;

    @Prop({ required: true }) public client!: ClientAccount;
    @Prop({ required: true }) public wills!: Array<ClientAccountWill>;

    private viewDialogVisible: boolean = false;
    private editDialogVisible: boolean = false;
    private deleteDialogVisible: boolean = false;
    private selectedWill: ClientAccountWill | null = null;

    private get sortedWills(): Array<ClientAccountWill> {
        return this.wills.sort((n1, n2) => {
            if (n1.createdDate! < n2.createdDate!) { return 1; }
            if (n1.createdDate! > n2.createdDate!) { return -1; }
            return 0;
        });
    }

    private userName(userId: string | null): string {
        const user = this.users.find((u) => u.id === userId);
        return user == null ? userId! : `${user.firstName == null ? '' : user.firstName} ${user.lastName == null ? '' : user.lastName}`;
    }

    private showViewDialog(will: ClientAccountWill): void {
        this.selectedWill = { ...will, executors: [...will.executors], guardians: [...will.guardians] };
        this.viewDialogVisible = true;
    }

    private showEditDialog(will: ClientAccountWill): void {
        this.selectedWill = { ...will, executors: [...will.executors], guardians: [...will.guardians] };
        this.editDialogVisible = true;
    }

    private showDeleteConfirmation(will: ClientAccountWill): void {
        this.selectedWill = { ...will, executors: [...will.executors], guardians: [...will.guardians] };
        this.deleteDialogVisible = true;
    }

    private async onEdit(will: ClientAccountWill): Promise<void> {
        try {
            await clientApi.updateClientWillHistory(this.client!.id!, this.selectedWill!);
            this.$emit('will-history-updated', { ...this.selectedWill! });
        } catch (e) {
            this.$snackbar.open({ message: 'Could not update client will history, please try again.', type: 'is-danger' });
        }

        this.onCancel();
    }

    private async onDelete(): Promise<void> {
        try {
            await clientApi.deleteClientWillHistory(this.client!.id!, this.selectedWill!.id!);
            this.$emit('will-history-deleted', { ...this.selectedWill! });
        } catch (e) {
            this.$snackbar.open({ message: 'Could not delete client will history, please try again.', type: 'is-danger' });
        }

        this.onCancel();
    }

    private onCancel(): void {
        this.viewDialogVisible = false;
        this.editDialogVisible = false;
        this.deleteDialogVisible = false;
    }
}
